<div class="align-middle">
  <img 
    [src]="imageUrl"
    class="max-w-xl w-10 h-10 rounded-full object-cover object-center"/>
</div>
